import PredkladatelUpdatePage from './PredkladatelUpdatePage';

export default PredkladatelUpdatePage;
